import { render } from "./NavigationList.vue?vue&type=template&id=a79e9a1c&scoped=true"
import script from "./NavigationList.vue?vue&type=script&lang=js"
export * from "./NavigationList.vue?vue&type=script&lang=js"

import "./NavigationList.vue?vue&type=style&index=0&id=a79e9a1c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a79e9a1c"]])

export default __exports__